import * as React from 'react'
import HaveQuestions from '../repairs/HaveQuestions'
import StillHaveQuestions from '../StillHaveQuestions'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import BuyingProcess from './BuyingProcess'

export const HaveQuestionsSection = ({ section }) => {
  switch (section.content) {
    case 'Contact Us':
      return <StillHaveQuestions heading={section.heading} />

    case 'How it works? (buying process)':
      return <BuyingProcess heading={section.heading} />

    default:
      return (
        <div className="w-10/12 max-w-[1366px] mx-auto  py-10">
          <hr />
          <HaveQuestions heading={section.heading} />
        </div>
      )
  }
}

HaveQuestionsSection.propTypes = {
  section: PropTypes.shape({
    heading: PropTypes.string,
    content: PropTypes.string,
  }),
}

export const query = graphql`
  fragment HaveQuestionsSection on STRAPI__COMPONENT_SECTION_COMMON_QUESTIONS {
    id
    heading
    content
    strapi_component
  }
`

export default HaveQuestionsSection
